import React, {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
import {useSelector} from "react-redux";

import {useMediaQuery} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {RootState, useAppDispatch} from "../../redux/store";
import Button from "@material-ui/core/Button";
import {useLocation} from "react-router";

const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        position: "relative",
        zIndex: 1,
    },
    button: {
        marginTop: "20px"
    },
    buttonMob: {
        marginTop: "10px",
        marginBottom: "5px"
    },
});


const BeforeLogin = ({setLogin}) => {
    const classes = useStyles();
    const theme = useTheme();
    const path = useLocation();
    const branding = useSelector((state: RootState) => state?.branding);
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const headerText = useSelector((state: RootState) => state?.branding.headerText)?.split("<>")?.join("\n");
    const bodyText = useSelector((state: RootState) => state?.branding.bodyText)?.split("<>")?.join("\n");
    const history = useHistory();
    const title = headerText ? headerText :
        branding.type === "CLINIC" ?
            "Your virtual care veterinarians are online to help you identify the best next steps for your pet. We are here to help you with..."
            :
            "Licensed veterinarians are online to share expert advice, offer at-home treatment options, and put your pet on a path to better health. We are here to help you with...";
    const description = bodyText ? bodyText :
        branding.type === "CLINIC" ?
            "After-hours guidance \n" +
            "\n" +
            "Follow-up after your in-person appointment\n" +
            "\n" +
            "Advice until you’re able to be seen in person"
            :
            "Food & nutrition\n" +
            "\n" +
            "Weight management\n" +
            "\n" +
            "Itching & skin problems\n" +
            "\n" +
            "Coughing & sneezing\n" +
            "\n" +
            "Vomiting & diarrhea\n" +
            "\n" +
            "Eye & ear issues\n" +
            "\n" +
            "Minor injuries\n" +
            "\n" +
            "Motion sickness & travel anxiety\n" +
            "\n" +
            "Fleas, ticks, & worms\n" +
            "\n" +
            "General pet care questions";
    return (
        <Container className={classes.containerRoot} maxWidth="sm">
            <Card className={classes.cardRoot} style={{paddingBottom: isWhiteLabel ? "0" : "40px"}}>
                <Box margin={isMobile ? "15px 0" : "0"} display="flex" justifyContent="center">
                    {
                        <img
                            alt="brand logo" 
                            src={branding.logo}
                            width="60%"
                            height="60%"
                        />
                    }
                </Box>
                <Box margin={isMobile ? "0" : "35px 0"}>
                    <Typography
                        dangerouslySetInnerHTML={{ __html: title}}
                        variant={isMobile ? "h4" : "h3"}
                        style={{whiteSpace: "pre-line"}}
                    >
                    </Typography>
                </Box>
                <Box margin={isMobile ? "0" : "35px 0"}>
                    <Typography
                        variant="h6"
                        align="center"
                        dangerouslySetInnerHTML={{ __html: description}}
                        style={{whiteSpace: "pre-line"}}
                    ></Typography>
                </Box>
                {branding.partnerStatus === "ACTIVE" && <>
                    <Box margin={isMobile ? "0" : "35px 0"}>
                        <Typography
                            variant={isMobile ? "h4" : "h3"}
                            align="center"
                        >
                            Ready to get started?
                        </Typography>
                        <Button
                            type="button"
                            color="primary"
                            variant="contained"
                            data-testid="submitButton"
                            className={isMobile ? classes.buttonMob : classes.button}
                            fullWidth
                            onClick={() => {
                                history.push("/signUp", path.state);
                            }}
                        >
                            Create my free account
                        </Button>
                    </Box>
                    <Box margin={isMobile ? "0" : "35px 0"}>
                        <Typography
                            variant={isMobile ? "h4" : "h3"}
                            align="center"
                        >
                            Already have an account with us?
                        </Typography>
                        <Button
                            type="button"
                            color="primary"
                            variant="contained"
                            data-testid="submitButton"
                            className={isMobile ? classes.buttonMob : classes.button}
                            fullWidth
                            onClick={() => {
                                history.push("/login/?login=true",  path.state);
                            }}
                        >
                            Login
                        </Button>
                    </Box>
                </>}
            </Card>
        </Container>
    );
};

export default BeforeLogin;
